import React from 'react'
import {Icon} from 'semantic-ui-react'

const chipStyle = {
  backgroundColor: 'rgb(230,241,251)',
  color: 'rgb(12,68,124)',
  padding: '3px 9px',
  borderRadius: '17px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  marginLeft: '10px',
  verticalAlign: 'middle',
  cursor: 'default'
}

// forwardRef + rest props so Popup can attach its ref and hover handlers to the
// span — it injects them by cloning the trigger, and a plain function component
// would silently drop them
const PoeChip = React.forwardRef((props, ref) => {
  return (
    <span ref={ref} {...props} style={chipStyle}>
      <Icon name='anchor' style={{fontSize: '13px', marginRight: '2px'}}/>POE
    </span>
  )
})

const POE_POPUP_TEXT = 'The customer picks these goods up at the port — they do not come to the warehouse first.'

export {PoeChip, POE_POPUP_TEXT}
